export default {
  // Cảnh báo người dùng cùng IP
  'riskDimension.ip.title': 'Cảnh báo người dùng cùng IP',
  'riskDimension.ip.ipAddress': 'Địa chỉ IP',
  'riskDimension.ip.ipAddressPlaceholder': 'Nhập địa chỉ IP',
  'riskDimension.ip.memberAccount': 'Tên người dùng',
  'riskDimension.ip.memberAccountPlaceholder': 'Nhập tên người dùng',
  'riskDimension.ip.minMemberCount': 'Số lượng liên kết ≥',
  'riskDimension.ip.minMemberCountPlaceholder': 'Nhập',
  'riskDimension.ip.minRiskCount': 'Số lượng kiểm soát rủi ro ≥',
  'riskDimension.ip.minRiskCountPlaceholder': 'Nhập',
  'riskDimension.ip.query': 'Tìm kiếm',
  'riskDimension.ip.reset': 'Đặt lại',
  'riskDimension.ip.export': 'Xuất',
  
  // Cột bảng
  'riskDimension.ip.table.ipAddress': 'Địa chỉ IP',
  'riskDimension.ip.table.totalMembers': 'Tổng người dùng',
  'riskDimension.ip.table.riskMembers': 'Số lượng rủi ro',
  'riskDimension.ip.table.details': 'Chi tiết',
  'riskDimension.ip.table.lastUpdateTime': 'Cập nhật lần cuối',
  'riskDimension.ip.table.action': 'Thao tác',
  'riskDimension.ip.table.view': 'Xem',
  'riskDimension.ip.table.expand': 'Mở rộng',
  'riskDimension.ip.table.more': 'Thêm',
  'riskDimension.ip.table.total': 'Tổng {total} bản ghi',
  
  // Modal xem nhanh
  'riskDimension.ip.quickView.title': 'Danh sách người dùng liên quan',
  'riskDimension.ip.quickView.ipLabel': 'Địa chỉ IP',
  'riskDimension.ip.quickView.searchPlaceholder': 'Tìm tài khoản',
  'riskDimension.ip.quickView.noResults': 'Không tìm thấy tài khoản',
  'riskDimension.ip.quickView.showing': 'Hiển thị',
  
  // Modal chi tiết
  'riskDimension.ip.detail.title': 'Địa chỉ IP',
  'riskDimension.ip.detail.summary': 'Tổng {total} người dùng, {risk} đã thiết lập kiểm soát rủi ro',
  'riskDimension.ip.detail.batchSetRisk': 'Thiết lập hàng loạt',
  'riskDimension.ip.detail.searchPlaceholder': 'Tìm tên người dùng',
  'riskDimension.ip.detail.search': 'Tìm kiếm',
  'riskDimension.ip.detail.select': 'Chọn',
  'riskDimension.ip.detail.memberAccount': 'Tên người dùng',
  'riskDimension.ip.detail.currentRisk': 'Rủi ro hiện tại',
  'riskDimension.ip.detail.setRiskLevel': 'Thiết lập mức rủi ro',
  'riskDimension.ip.detail.batchSetPending': 'Chức năng đang phát triển',
  
  // Mức rủi ro
  'riskDimension.riskLevel.limitLogin': 'Hạn chế đăng nhập',
  'riskDimension.riskLevel.limitDeposits': 'Hạn chế nạp tiền',
  'riskDimension.riskLevel.limitWithdrawal': 'Hạn chế rút tiền',
  'riskDimension.riskLevel.limitDiscount': 'Hạn chế ưu đãi',
  'riskDimension.riskLevel.potentialRisk': 'Rủi ro tiềm ẩn',
  'riskDimension.riskLevel.sameIp': 'Cùng IP rủi ro',
  'riskDimension.riskLevel.sameDevice': 'Cùng thiết bị rủi ro',
  'riskDimension.riskLevel.sameBankCard': 'Cùng thẻ ngân hàng rủi ro',
  'riskDimension.riskLevel.sameWallet': 'Cùng ví rủi ro',
  
  // Modal thiết lập mức rủi ro
  'riskDimension.setRisk.title': 'Thiết lập mức rủi ro',
  'riskDimension.setRisk.batchTitle': 'Thiết lập hàng loạt',
  'riskDimension.setRisk.members': 'người dùng',
  'riskDimension.setRisk.riskLevel': 'Mức rủi ro',
  'riskDimension.setRisk.selectPlaceholder': 'Chọn mức rủi ro',
  'riskDimension.setRisk.loginLimitType': 'Loại hạn chế đăng nhập',
  'riskDimension.setRisk.loginLimitTypePlaceholder': 'Chọn loại hạn chế',
  'riskDimension.setRisk.loginLimitTypeRequired': 'Vui lòng chọn loại hạn chế',
  'riskDimension.setRisk.remark': 'Ghi chú',
  'riskDimension.setRisk.remarkPlaceholder': 'Nhập ghi chú',
  'riskDimension.setRisk.confirm': 'Xác nhận',
  'riskDimension.setRisk.cancel': 'Hủy',
  'riskDimension.setRisk.success': 'Thiết lập thành công',
  'riskDimension.setRisk.batchSuccess': 'Thiết lập thành công {count} người dùng',
  'riskDimension.setRisk.error': 'Thiết lập thất bại',
  'riskDimension.setRisk.missingMemberId': 'Thiếu ID thành viên',
  
  // Modal chi tiết
  'riskDimension.ip.detail.selectMembersFirst': 'Vui lòng chọn người dùng trước',
  
  // Thông báo
  'riskDimension.message.queryFailed': 'Truy vấn thất bại',
  'riskDimension.message.queryMemberListFailed': 'Truy vấn danh sách thất bại',
  'riskDimension.message.exportLoading': 'Đang tạo tác vụ xuất, vui lòng đợi...',
  'riskDimension.message.exportSuccess': 'Tạo tác vụ xuất thành công. Vui lòng kiểm tra danh sách tải xuống.',
  'riskDimension.message.exportFailed': 'Xuất thất bại',
  
  // Cảnh báo người dùng cùng thiết bị
  'riskDimension.device.title': 'Cảnh báo người dùng cùng thiết bị',
  'riskDimension.device.deviceId': 'ID thiết bị',
  'riskDimension.device.deviceIdPlaceholder': 'Nhập ID thiết bị',
  'riskDimension.device.memberAccount': 'Tên người dùng',
  'riskDimension.device.memberAccountPlaceholder': 'Nhập tên người dùng',
  'riskDimension.device.minMemberCount': 'Số lượng liên kết ≥',
  'riskDimension.device.minMemberCountPlaceholder': 'Nhập',
  'riskDimension.device.minRiskCount': 'Số lượng kiểm soát rủi ro ≥',
  'riskDimension.device.minRiskCountPlaceholder': 'Nhập',
  'riskDimension.device.query': 'Tìm kiếm',
  'riskDimension.device.reset': 'Đặt lại',
  'riskDimension.device.export': 'Xuất',
  'riskDimension.device.table.deviceId': 'ID thiết bị',
  'riskDimension.device.table.totalMembers': 'Tổng người dùng',
  'riskDimension.device.table.riskMembers': 'Số lượng rủi ro',
  'riskDimension.device.table.details': 'Chi tiết',
  'riskDimension.device.table.lastUpdateTime': 'Cập nhật lần cuối',
  'riskDimension.device.table.action': 'Thao tác',
  'riskDimension.device.table.view': 'Xem',
  'riskDimension.device.table.more': 'Thêm',
  'riskDimension.device.table.total': 'Tổng {total} bản ghi',
  'riskDimension.device.detail.title': 'ID thiết bị',
  'riskDimension.device.detail.summary': 'Tổng {total} người dùng, {risk} đã thiết lập kiểm soát rủi ro',
  'riskDimension.device.detail.batchSetRisk': 'Thiết lập hàng loạt',
  'riskDimension.device.detail.searchPlaceholder': 'Tìm tên người dùng',
  'riskDimension.device.detail.search': 'Tìm kiếm',
  'riskDimension.device.detail.memberAccount': 'Tên người dùng',
  'riskDimension.device.detail.currentRisk': 'Rủi ro hiện tại',
  'riskDimension.device.detail.setRiskLevel': 'Thiết lập mức rủi ro',
  'riskDimension.device.detail.selectMembersFirst': 'Vui lòng chọn người dùng trước',
  'riskDimension.device.quickView.title': 'Danh sách người dùng liên quan',
  'riskDimension.device.quickView.deviceLabel': 'ID thiết bị',
  'riskDimension.device.quickView.searchPlaceholder': 'Tìm tài khoản',
  'riskDimension.device.quickView.noResults': 'Không tìm thấy tài khoản',
  'riskDimension.device.quickView.showing': 'Hiển thị',
  
  // Cảnh báo người dùng cùng thẻ ngân hàng
  'riskDimension.bank.title': 'Cảnh báo người dùng cùng thẻ ngân hàng',
  'riskDimension.bank.bankCard': 'Số thẻ ngân hàng',
  'riskDimension.bank.bankCardPlaceholder': 'Nhập số thẻ ngân hàng',
  'riskDimension.bank.bankAccountName': 'Tên tài khoản ngân hàng',
  'riskDimension.bank.bankAccountNamePlaceholder': 'Nhập tên tài khoản ngân hàng',
  'riskDimension.bank.memberAccount': 'Tên người dùng',
  'riskDimension.bank.memberAccountPlaceholder': 'Nhập tên người dùng',
  'riskDimension.bank.minMemberCount': 'Số lượng liên kết ≥',
  'riskDimension.bank.minMemberCountPlaceholder': 'Nhập',
  'riskDimension.bank.minRiskCount': 'Số lượng kiểm soát rủi ro ≥',
  'riskDimension.bank.minRiskCountPlaceholder': 'Nhập',
  'riskDimension.bank.query': 'Tìm kiếm',
  'riskDimension.bank.reset': 'Đặt lại',
  'riskDimension.bank.export': 'Xuất',
  'riskDimension.bank.table.bankCard': 'Số thẻ ngân hàng',
  'riskDimension.bank.table.bankAccountName': 'Tên tài khoản ngân hàng',
  'riskDimension.bank.table.totalMembers': 'Tổng người dùng',
  'riskDimension.bank.table.riskMembers': 'Số lượng rủi ro',
  'riskDimension.bank.table.details': 'Chi tiết',
  'riskDimension.bank.table.lastUpdateTime': 'Cập nhật lần cuối',
  'riskDimension.bank.table.action': 'Thao tác',
  'riskDimension.bank.table.view': 'Xem',
  'riskDimension.bank.table.more': 'Thêm',
  'riskDimension.bank.table.total': 'Tổng {total} bản ghi',
  'riskDimension.bank.detail.title': 'Số thẻ ngân hàng',
  'riskDimension.bank.detail.summary': 'Tổng {total} người dùng, {risk} đã thiết lập kiểm soát rủi ro',
  'riskDimension.bank.detail.batchSetRisk': 'Thiết lập hàng loạt',
  'riskDimension.bank.detail.searchPlaceholder': 'Tìm tên người dùng',
  'riskDimension.bank.detail.search': 'Tìm kiếm',
  'riskDimension.bank.detail.memberAccount': 'Tên người dùng',
  'riskDimension.bank.detail.currentRisk': 'Rủi ro hiện tại',
  'riskDimension.bank.detail.setRiskLevel': 'Thiết lập mức rủi ro',
  'riskDimension.bank.detail.selectMembersFirst': 'Vui lòng chọn người dùng trước',
  'riskDimension.bank.quickView.title': 'Danh sách người dùng liên quan',
  'riskDimension.bank.quickView.bankCardLabel': 'Số thẻ ngân hàng',
  'riskDimension.bank.quickView.searchPlaceholder': 'Tìm tài khoản',
  'riskDimension.bank.quickView.noResults': 'Không tìm thấy tài khoản',
  'riskDimension.bank.quickView.showing': 'Hiển thị',
  
  // Cảnh báo người dùng cùng ví
  'riskDimension.wallet.title': 'Cảnh báo người dùng cùng ví',
  'riskDimension.wallet.walletNumber': 'Số ví',
  'riskDimension.wallet.walletNumberPlaceholder': 'Nhập số ví',
  'riskDimension.wallet.walletType': 'Loại ví',
  'riskDimension.wallet.walletTypePlaceholder': 'Chọn loại ví',
  'riskDimension.wallet.walletType.USDT': 'USDT',
  'riskDimension.wallet.walletType.BTC': 'BTC',
  'riskDimension.wallet.walletType.ETH': 'ETH',
  'riskDimension.wallet.walletType.OTHER': 'Khác',
  'riskDimension.wallet.memberAccount': 'Tên người dùng',
  'riskDimension.wallet.memberAccountPlaceholder': 'Nhập tên người dùng',
  'riskDimension.wallet.minMemberCount': 'Số lượng liên kết ≥',
  'riskDimension.wallet.minMemberCountPlaceholder': 'Nhập',
  'riskDimension.wallet.minRiskCount': 'Số lượng kiểm soát rủi ro ≥',
  'riskDimension.wallet.minRiskCountPlaceholder': 'Nhập',
  'riskDimension.wallet.query': 'Tìm kiếm',
  'riskDimension.wallet.reset': 'Đặt lại',
  'riskDimension.wallet.export': 'Xuất',
  'riskDimension.wallet.table.walletNumber': 'Số ví',
  'riskDimension.wallet.table.walletType': 'Loại ví',
  'riskDimension.wallet.table.totalMembers': 'Tổng người dùng',
  'riskDimension.wallet.table.riskMembers': 'Số lượng rủi ro',
  'riskDimension.wallet.table.details': 'Chi tiết',
  'riskDimension.wallet.table.lastUpdateTime': 'Cập nhật lần cuối',
  'riskDimension.wallet.table.action': 'Thao tác',
  'riskDimension.wallet.table.view': 'Xem',
  'riskDimension.wallet.table.more': 'Thêm',
  'riskDimension.wallet.table.total': 'Tổng {total} bản ghi',
  'riskDimension.wallet.detail.title': 'Số ví',
  'riskDimension.wallet.detail.summary': 'Tổng {total} người dùng, {risk} đã thiết lập kiểm soát rủi ro',
  'riskDimension.wallet.detail.batchSetRisk': 'Thiết lập hàng loạt',
  'riskDimension.wallet.detail.searchPlaceholder': 'Tìm tên người dùng',
  'riskDimension.wallet.detail.search': 'Tìm kiếm',
  'riskDimension.wallet.detail.memberAccount': 'Tên người dùng',
  'riskDimension.wallet.detail.currentRisk': 'Rủi ro hiện tại',
  'riskDimension.wallet.detail.setRiskLevel': 'Thiết lập mức rủi ro',
  'riskDimension.wallet.detail.selectMembersFirst': 'Vui lòng chọn người dùng trước',
  'riskDimension.wallet.quickView.title': 'Danh sách người dùng liên quan',
  'riskDimension.wallet.quickView.walletNumberLabel': 'Số ví',
  'riskDimension.wallet.quickView.searchPlaceholder': 'Tìm tài khoản',
  'riskDimension.wallet.quickView.noResults': 'Không tìm thấy tài khoản',
  'riskDimension.wallet.quickView.showing': 'Hiển thị',
};

